import type {PartValueRenderer} from '../../schema/types';
import {Icon} from '../../components';

export const TrueAsVerifiedIcon: PartValueRenderer = ({value}) => {
  return value ? <Icon icon="Verified" /> : null;
};
